/**
 * OVERRIDE Header.jsx
 * REASON: odc usa um Header customizado, Semantic UI-free,
 * construído com @plone/components (React Aria).
 *
 * Para sobrescrever o Header do odc em outro addon,
 * faça shadow deste arquivo, não do original do Volto.
 */
import Header from 'odc.volto/components/Header/Header';

export default Header;
